<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
    		<el-form-item>
    			<el-date-picker v-model="order.date" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%" @change="orderisselect=true" :unlink-panels="false"></el-date-picker>
    		</el-form-item>
    		<el-form-item>
	    		<el-select v-model="order.status" clearable placeholder="请选择状态" @change="orderisselect=true">
			        <el-option v-for="(item,index) in statuslists" :label="item.name" value="a0" :key="index" v-if="item.id==0"></el-option>
			        <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index" v-if="item.id > 0"></el-option>
			    </el-select>
    		</el-form-item>
			<el-form-item>
	    		<el-select v-model="order.applyid" filterable clearable placeholder="请选择供应商" @change="orderisselect=true">
			        <el-option v-for="(item,index) in allapplylists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
			    </el-select>
    		</el-form-item>

    		<el-form-item>
	    		<el-select v-model="order.account" clearable placeholder="请选择支付类型" @change="orderisselect=true">
			        <el-option v-for="(item,index) in accountLists" :label="item.name" value="a0" :key="index" v-if="item.id==0"></el-option>
			        <el-option v-for="(item,index) in accountLists" :label="item.name" :value="item.id" :key="index" v-if="item.id > 0"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item>
    			<el-input placeholder="请输入采购退货单号" v-model="order.key" clearable style="width:100%" @change="orderisselect=true"></el-input>
    		</el-form-item>
    		<el-form-item>
    			<el-button type="warning" icon="el-icon-search" @click="getorderlists">查询</el-button>			    
    		</el-form-item>
			<el-form-item>
    			<el-button type="warning" icon="el-icon-circle-plus-outline" @click="add">新增</el-button>				    
    		</el-form-item>
			<el-form-item>
				<el-button type="warning" icon="el-icon-circle-plus-outline" @click="exportdata">导出</el-button>			    
    		</el-form-item>
    	</el-form>
    	
    	<div class="backborder2" style="margin-top:10px">
	    	<el-table :data="orderlists" style="width: 100%" v-loading="orderLoading">
	    		<el-table-column type="expand">
		            <template slot-scope="props">
		              <div style="width:99%;color:#606266;padding:15px 0;font-size:13px"><span>备注：{{props.row.note}}</span></div>
		              <el-table :data="props.row.goods">
		                <el-table-column prop="name" label="商品名称" min-width="250">
							<template slot-scope="scope">
								<div style="float:left;width:100%;font-size:13px;line-height:23px;">{{scope.row.name}}</div>
								<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">编号：{{scope.row.number}}</div>
							</template>
						</el-table-column>
		                <el-table-column prop="num" label="数量" min-width="120" align="center">
							<template slot-scope="scope">
								<div style="float:left;width:100%;font-size:14px;line-height:23px;">{{scope.row.num}} {{scope.row.unit}}</div>
							</template>
						</el-table-column>
		                <el-table-column label="进货价" min-width="120" align="center">
							<template slot-scope="scope"><div style="font-size:14px">{{scope.row.buy|CFMprice}}</div></template>
						</el-table-column>
		                <el-table-column label="合计" min-width="120" align="center">
							<template slot-scope="scope"><div  style="font-size:14px">{{scope.row.total|CFMprice}}</div></template>
						</el-table-column>
		                <el-table-column label="状态" min-width="120" align="center">
				        	<template slot-scope="scope">
								<div style="float:left;width:100%;font-size:13px;line-height:23px;" v-if="scope.row.status==0 && scope.row.isdel==0">未审核</div>
								<div style="float:left;width:100%;font-size:13px;line-height:23px;" v-if="scope.row.status==1 && scope.row.isdel==0">已审核</div>
								<div style="float:left;width:100%;font-size:13px;line-height:23px;" v-if="scope.row.status==2 && scope.row.isdel==0">已完成</div>
								<div style="float:left;width:100%;font-size:13px;line-height:23px;"  v-if="scope.row.isdel==1">已退货</div>
				        	</template>
				        </el-table-column>
		              </el-table>
		            </template>
	            </el-table-column>
	    		
		        <el-table-column label="退货单号" prop="documents" min-width="250">
					<template slot-scope="scope">
						<div style="float:left;width:100%;">{{scope.row.documents}}</div>
						<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">
							支付方式：
							<span v-if="scope.row.account==0">未付款</span>
							<span v-if="scope.row.account==1">预付款</span>
							<span v-if="scope.row.account > 1">{{scope.row.accountname}}</span>
						</div>
						<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">打印次数：{{scope.row.printnumber}}</div>
					</template>
				</el-table-column>
				<el-table-column label="供应商" prop="applyname" align="center" min-width="130">
					<template slot-scope="scope">
						<div style="float:left;width:100%;font-size:13px;">{{scope.row.applyname && scope.row.applyname!='' ? scope.row.applyname : '-'}}</div>
					</template>
				</el-table-column>
		        <el-table-column label="订单总额" align="center" min-width="130">
					<template slot-scope="scope"><div style="font-size:14px">{{scope.row.total|CFMprice}}</div></template>
				</el-table-column>
		        <el-table-column label="优惠金额" align="center" min-width="130">
					<template slot-scope="scope"><div style="font-size:14px">{{scope.row.derate|CFMprice}}</div></template>
				</el-table-column>
		        <el-table-column label="实付金额" align="center" min-width="130">
					<template slot-scope="scope"><div style="font-size:14px">{{scope.row.real|CFMprice}}</div></template>
				</el-table-column>
		        <el-table-column label="入库时间" prop="inputtime" align="center" min-width="130">
					<template slot-scope="scope"><div style="font-size:14px">{{scope.row.inputtime}}</div></template>
				</el-table-column>
		        <el-table-column label="状态" align="center" min-width="130">
		        	<template slot-scope="scope">
		        		<span style="font-size:13px" v-if="scope.row.status==0 && scope.row.isdel==0">未审核</span>
		        		<span style="font-size:13px" v-if="scope.row.status==1 && scope.row.isdel==0">已审核</span>
		        		<span style="font-size:13px" v-if="scope.row.status==2 && scope.row.isdel==0">已完成</span>
		                <span style="font-size:13px" v-if="scope.row.isdel==1">已删除</span>
		        	</template>
		        </el-table-column>
		        <el-table-column label="操作" align="center" min-width="200" fixed="right">
		        	<template slot-scope="scope">
		        		<el-button type="warning" size="small" round v-if="scope.row.isdel==0" @click="showorder(scope.row)">查看</el-button>
		        		<el-button type="warning" size="small" v-if="scope.row.status==0 && scope.row.isdel==0" round @click="editorder(scope.row)">编辑</el-button>
	                    <el-button type="" size="small" v-if="scope.row.status==0 && scope.row.isdel==0" @click="delCurrent(scope.row)" round>删除</el-button>
					</template>
		        </el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="order.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="order.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="order_total_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
      	</div>
      	
      	<!--------------- 新增采购退货界面 --------------->
    	<el-dialog title="添加/编辑采购退货单" :visible.sync="addDialog" top="3vh" width="90%" @close='handleDialogClose'>
    		<el-form :inline="true" class="demo-form-inline" ref="search" size="medium">
    			<!--
    			<el-form-item style="width:12%">
		    		<el-select v-model="create.applyid" clearable filterable remote reserve-keyword placeholder="请选择供应商" @change="changesupplier">
				        <el-option v-for="(item,index) in supplierlists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
				    </el-select> 
		    	</el-form-item>
    			<el-form-item style="width:10%">
    				<el-select v-model="create.clerkid" clearable filterable placeholder="请选销售员" style="width:100%">
						<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
    			</el-form-item>
    			-->
		        <el-form-item>
		            <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
		          	    <template slot="prepend">查找</template>
		          	    <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
		            </el-input>
		        </el-form-item>
		        <el-form-item>
		        	<el-button type="primary" @click="addDialogmore">批量添加商品</el-button>
		        	<el-button type="danger" @click="clearall">清空商品</el-button>
		        </el-form-item>
		    </el-form>
		    
		    <el-table :data="create.goods" show-summary :summary-method="totalRule" style="width: 100%" v-loading="goodsListLoading">    		    	
	        	<el-table-column label="编号" prop="number" width="90" align="center"></el-table-column>
	        	<el-table-column label="商品名称" prop="name"></el-table-column>
	        	<el-table-column label="规格" prop="spec" width="100" align="center"></el-table-column>
	        	<el-table-column label="单位" prop="unit" width="85" align="center">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].unit"  @focus="getUnitlists(props.row)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="成本价" width="145">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].buy"  @blur="setgoodsbuy(props.row)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="数量" width="100">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].num"  @blur="setgoodsnum(props.row)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="退货仓库" width="130">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].warehousename"  @focus="changewarehouse(props.row)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="小计" width="135">
	        		<template slot-scope="props">
	        			<el-input size="small" v-model="create.goods[props.$index].total"  @blur="setgoodstotal(props.row)"></el-input>
	        		</template>
	        	</el-table-column>
	        	<el-table-column label="操作" width="100" align="center">
	        		<template slot-scope="props">
	        			<el-button type="warning" size="small" icon="el-icon-document" circle  @click="copygoods(props.row)"></el-button>
	        			<el-button type="danger" size="small" icon="el-icon-delete" circle  @click="delgoods(props.row)"></el-button>
	        		</template>
	        	</el-table-column>	        
      		</el-table>
      		
      		<el-col :span="24">&nbsp;</el-col>
	    	<el-col :span="24">
				<el-form ref="create" :model="create" label-width="70px">
					<el-col :span="6">
						<el-form-item label="单据编号" style="width:90%">
						    <el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="付款帐号" style="width:90%">
							<el-select v-model="create.account" placeholder="未付款">
						    	<el-option v-for="(item,index) in accountLists" :key="index" label="未付款" value="0" v-if="item.id==0"></el-option>
						        <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
						    </el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="订单金额" style="width:90%">
						    <el-input v-model="create.total" placeholder="订单金额" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="优惠金额" style="width:90%">
						    <el-input v-model="create.derate" placeholder="优惠金额" @blur="changederate"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="应付金额" style="width:90%">
						    <el-input v-model="create.real" placeholder="应付金额" @blur="changereal"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="退货备注" style="width:90%">
						    <el-input placeholder="退货备注" v-model="create.note"></el-input>
						</el-form-item>
					</el-col>
				</el-form>

	    	</el-col>
	    	
	    	<div slot="footer" class="dialog-footer">
	      	    <el-button @click="addDialog = false">取 消</el-button>
	            <el-button type="primary" :loading="addorderLoading" @click="createSave">保存</el-button>
	            <el-button type="warning" :loading="verifyorderLoading" @click="verifySave">确认审核</el-button>
	            <el-button type="warning" :loading="verifyandprintorderLoading" @click="verifyandprintSave">确认审核并打印</el-button>
	            <el-button type="danger" :loading="delorderLoading" v-if="create.id > 0 && create.status==0" @click="delSave">删除订单</el-button>
	        </div>
    	
    			<!--
	  			<el-col :span="24">
	  				<div style="border:1px solid #ebeef5;background:#ebeef5;border-radius:6px;padding:20px;margin-bottom:20px;float:left">
					    <el-form ref="create" :model="create" label-width="70px">
					    	<el-col :span="6">
						        <el-form-item label="收货仓库" style="width:90%">
							        <el-select v-model="create.warehouse" placeholder="请选择收货仓库">
							            <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
							        </el-select> 
						        </el-form-item> 
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="付款日期" style="width:90%">
						            <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.paydate" style="width:99%;" value-format="yyyy-MM-dd"></el-date-picker>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="付款帐号" style="width:90%">
						            <el-select v-model="create.account" placeholder="请选择付款帐号">
						            	<el-option v-for="(item,index) in accountLists" :key="index" label="未付款" value="0" v-if="item.id==0"></el-option>
						            	<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
						            </el-select>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="单据编号" style="width:90%">
						        	<el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="录单日期" style="width:90%">
						            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择录单日期" v-model="create.inputdate" style="width:99%;"></el-date-picker>
						        </el-form-item>
					        </el-col>
					        <el-col :span="6">
						        <el-form-item label="入库备注" style="width:90%">
						            <el-input placeholder="备注" v-model="create.note"></el-input>
						        </el-form-item>
					        </el-col>
					    </el-form>
	  				</div>
	  			</el-col>
	  			-->
      		   
    	</el-dialog>
    	
    	<!----------批量添加产品----------->
  		<el-dialog title="添加产品" :visible.sync="addproductDialog" width="80%" top="1vh">
      		<el-form :inline="true" class="demo-form-inline" size="medium" style="margin-top:15px">
	          	<el-form-item style="width:15%">
		            <el-select v-model="productquery.brandid" filterable clearable placeholder="按品牌"  @change="selectbrand">
		              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
		            </el-select>
	          	</el-form-item>
	          	<el-form-item style="width:15%">
	                <el-cascader :options="categorylist" clearable v-model="productquery.catid" placeholder="请选择分类" @change="selectcate"></el-cascader>
	          	</el-form-item>
	          	<!--
	            <el-form-item style="width:15%;">
		            <el-select v-model="productquery.warehouse" clearable placeholder="请选择仓库" @change="selectwarehouse">
		                <el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index"></el-option>
		            </el-select>
	          	</el-form-item>
	          	-->
	          	<el-form-item ref="productquery" :model="productquery" style="width:19%">
	            	<el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" clearable v-model="productquery.key" @keyup.enter.native="getProductList" @change="productselect=true" @input="changesearchkey"></el-input>
	          	</el-form-item>
	          	<el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
	            	<el-button type="danger" icon="el-icon-delete" @click="cleargoods">清空勾选</el-button>
	          	</el-form-item>
        	</el-form>        	
        	
      		<!------------------------search end---------------------->
	      	<el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall"  >
	            <el-table-column type="selection" width="50"></el-table-column>
	            <el-table-column prop="number" label="编号" width="90"></el-table-column>
	            <el-table-column prop="brandname" label="品牌名称" width="120"></el-table-column>
	            <el-table-column prop="name" label="名称"></el-table-column>
	            <el-table-column prop="spec" label="规格" width="120"></el-table-column>
	            <el-table-column prop="cost" label="成本价" width="140"></el-table-column>
	            <el-table-column prop="inventory" label="可退数量" width="110"></el-table-column>
	      	</el-table>
      		<div class="block">      		
            <!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_product_rows">
            </el-pagination>
            <!--分页end-->
      		</div>
	        <div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="addproductDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
	        </div>	        
  		</el-dialog>
  		
  		<!---------------------------获取单位--------------------------->
	    <el-dialog title="选择单位" :visible.sync="unitDialog">
	        <el-table :data="unitlists.lists" style="width: 100%" v-loading="unitListLoading">
		        <el-table-column label="单位" prop="unit"></el-table-column>
		        <el-table-column label="进货价" prop="buy"></el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="success" size="mini" icon="el-icon-check" circle  @click="changeUnitSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
	    </el-dialog>
	    
	    <!---------------------------修改仓库--------------------------->
    	<el-dialog title="选择仓库" :visible.sync="wareDialog" width="40%">
      		<el-table :data="wareHouseLists" style="width: 100%" v-loading="wareListLoading">
        		<el-table-column label="仓库名称" prop="name"></el-table-column>
        		<el-table-column label="选择" width="80">
          			<template slot-scope="scope">
            			<el-button type="success" size="small" circle icon="el-icon-check"  @click="changewarehouseSave(scope.row)"></el-button>
          			</template>
        		</el-table-column>
      		</el-table>
    	</el-dialog>
    	
    	
    	<!----------- 订单打印页面 ----------------> 
	    <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
  	  		<div style="width:100%;text-align:right">每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条</div>	
      			<div id="printContent" v-loading="printLoading">
          	  		<div v-for="(item,index) in printlists" :key="index">
          	  			<span style="float:right">{{item.pagesize}}</span>
	      	  			<DIV style="font-size:18px;padding-bottom:2px;margin-bottom:0" align="center" ><STRONG>采购退货单</STRONG></DIV>        
	      	  			<ul class="titlelists">
					  	    <!--<li >供货商名：{{item.applyname}}</li>-->
						    <li >单据编号：{{item.documents}}</li>
						    <!--<li >联系电话：{{item.phone}}</li>-->
						    <!--<li >采购人员：{{item.clerkname}}</li>-->
						    <li >出库备注：{{item.note}}</li>
						    <!--<li style="width:100%">联系地址：{{item.address}}</li>-->
				  	  	</ul>
	      			
	          			<TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
			 			    <TR class="contactcontent">
			 			    	<TD><DIV align=center><b>序号</b></DIV></TD>
				            	<TD ><DIV align=center><b>编号</b></DIV></TD>
				                <TD ><DIV align=center><b>商品</b></DIV></TD>
				                <TD ><DIV align=center><b>规格</b></DIV></TD>
				                <TD ><DIV align=center><b>单位</b></DIV></TD>
				                <TD v-if="pricePerm"><DIV align=center><b>单价</b></DIV></TD>
				                <TD ><DIV align=center><b>数量</b></DIV></TD>
				                <TD v-if="pricePerm"><DIV align=center><b>小计</b></DIV></TD>
								<TD ><DIV align=center><b>仓库</b></DIV></TD>
								<TD v-if="storageLocationStatus"><DIV align=center><b>货位</b></DIV></TD>
								<TD v-if="batchStatus" ><DIV align=center><b>批次号</b></DIV></TD>
								<TD v-if="batchStatus" ><DIV align=center><b>生产日期</b></DIV></TD>
								<TD v-if="batchStatus" ><DIV align=center><b>有效期</b></DIV></TD>
								<TD v-if="batchStatus" ><DIV align=center><b>到期日期</b></DIV></TD>
			                </TR>
				            <tr v-for="(tt,ii) in item.goods" :key="ii"  class="contactcontent">
				            	<TD v-text="tt.gsort" align="center"></TD>
					            <TD v-text="tt.number" align="center"></TD>
					            <TD v-text="tt.name" align=center style="padding-left:1%" ></TD>
					            <TD v-text="tt.spec" align=center style="padding-left:1%" ></TD>
					            <TD v-text="tt.unit" align="center" ></TD>
					            <TD v-if="pricePerm" align="center" >{{tt.buy|CFMprice}}</TD>
					            <TD v-text="tt.num" align="center" ></TD>
					            <TD v-if="pricePerm" align="center" >{{tt.total|CFMprice}}</TD>
								<TD ><DIV align=center>{{tt.warehouse_name}}</DIV></TD>
								<TD  v-if="storageLocationStatus"><DIV align=center>{{tt.full_code}}</DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center>{{tt.batch_sn}}</DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center>{{tt.start_date || '/'}}</DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center>{{tt.realvalidity}}{{ validityunitTemp[tt.validityunit] }}</DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center>{{tt.end_date || '/'}}</DIV></TD>
								
				            </tr>
				            <tr v-if="index+1==printlists.length " class="contactcontent">
					            <TD align="center">合计</TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD style="padding-left:1%" ></TD>
					            <TD v-if="pricePerm" align="center" ></TD>
					            <TD align="center" ></TD>
					            <TD align="center" >{{item.goodscount}}</TD>
					            <TD v-if="pricePerm" align="center" >{{item.total|CFMprice}}</TD>
								<TD ><DIV align=center></DIV></TD>
								<TD  v-if="storageLocationStatus"><DIV align=center></DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center></DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center></DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center></DIV></TD>
								<TD  v-if="batchStatus"><DIV align=center></DIV></TD>
				            </tr>
	      	  			</table>
	          			<TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
		          			<TBODY>
			          			<TR class="top1">
			          				<TD ><span>录单日期：{{item.inputtime}}</span></TD>
				          			<TD ><span>审核人：{{item.verifyername}}</span></TD>
				          			<TD ><span>操作人：{{item.managername}}</span></TD>
			          			</TR>
			          			<TR v-if="pricePerm" class="top1">				          			
				          			<TD ><span>合计金额：{{item.total|CFMprice}} 元</span></TD>
				          			<TD ><span>优惠金额：{{item.derate|CFMprice}} 元</span></TD>				          			
			          				<TD ><span>实付金额：{{item.real|CFMprice}} 元</span></TD>
			          			</TR>
		          			</TBODY>
	          			</TABLE>
	          			<div class="pageBreak"></div>
          			</div>          
	  			</div>
		      	<div slot="footer" class="dialog-footer">
			        <el-button @click="printerDialog = false" size="small">取 消</el-button>			        
			        <el-button type="primary" icon="el-icon-printer" @click="createnoSave" :loading="printorderLoading" size="small">打印订单</el-button>
			        <el-button type="danger" icon="el-icon-back" @click="cannelverify" :loading="cannelLoading" v-if="orderstatus==1" size="small">撤销审核</el-button>
			        <el-button type="danger" icon="el-icon-edit-outline" @click="finishorder" :loading="finishLoading" v-if="orderstatus==1" size="small">完成订单</el-button>
			        <el-button type="danger" icon="el-icon-edit-outline" @click="cannelfinish" :loading="cannelfinishLoading" v-if="orderstatus==2" size="small">撤销完成</el-button>
		      	</div>
  		</el-dialog>
	    <!----------- 订单打印页面 ---------------->
    	
    	
    </div>
    </transition>      
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Purcharserefund/index",
      transitionshow:true,
      actionauth:[],
      order:{
      	act:'lists',
		token:this.$cookies.get('token'),
		date:'',
		key:'',
		status:'',
		account:'',
		applyid:'',
		p:1,
		rollpage:10
      },
      orderisselect:false,
      wareHouseLists:[],
      statuslists:[
      	{id:1,name:'未审核'},
      	{id:2,name:'已审核'},
      	{id:3,name:'已完成'},
      	{id:4,name:'已撤销'},
      ],
	  allapplylists:[],
      accountLists:[],
      orderlists:[],
      orderLoading:false,
      order_total_rows:0,
      addDialog:false,
      create:{
      	  act:'add',
          token:this.$cookies.get('token'),
      	  id:0,
      	  applyid:'',
      	  clerkid:'',
      	  documents:'',
      	  account:'',
      	  total:0.00,
      	  real:0.00,
      	  derate:0.00,
      	  note:'',
      	  goods:[],
      },
      productquery: {
      	  act:'inventory',
          token:this.$cookies.get('token'),
      	  key:'',
      	  clerkid:'',
      	  applyid:'',
      	  brandid:'',
      	  catid:[],
      	  p:1,
      	  rollpage:10,  
      },
      sellerLists:[],
      supplierlists:[],
      addproductDialog:false,
      brandlists:[],
      categorylist:[],
      productlists:[],
      addListLoading:false,
      total_product_rows:0,
      addProductLoading:false,
      productselect:false,
      multipleSelection:[],      
	  nowtime:0,
	  timeoutflag:true,
      isopenselect:true,
      goodsListLoading:false,
      unitDialog:false,
      unitListLoading:false,
      unitlists:{
      	tempid:'',
      	lists:[]
      },
      warehouselists:{
      	tempid:'',
      	lists:[]
      },
      wareDialog:false,
      wareListLoading:false,
      addorderLoading:false,
      verifyorderLoading:false,
      verifyandprintorderLoading:false,
      delorderLoading:false,
      printLoading:false,
      printerDialog:false,
      printlists:[],
      rollpage:10,
      printorderLoading:false,
      cannelLoading:false,
      finishLoading:false,
      cannelfinishLoading:false,
      orderstatus:0,
	  pricePerm: false,
	  validityunitTemp: {
		1: '日',
		2: '月',
		3: '年'
	  },
	  storageLocationStatus: false,
	  batchStatus: false,
    }
  },
  
  mounted(){
      this.getactionauth(); //获取权限设置
      this.getWarehouse(); //获取代理商仓库信息
      this.getAccount(); //获取支付方式信息
      this.getorderlists(); //获取采购退货单信息
      this.getSeller(); //获取销售员
      //this.getSupplier(); //获取供应商信息
      this.getBrand(); //获取商品品牌信息
      this.getCategoryList(); //获取产品分类信息
	  this.getAllapplylists(); //获取供应商列表
	  this.getPrintPermission()
	  this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
	  this.batchStatus = localStorage.getItem('batchStatus') == 'true'
  },


  filters: {
	/** 价格信息保留两位小数 **/
 	CFMprice(value) {
		var price=parseFloat(value); //修剪去小数点后多余的0
		var numsobj=price.toString().split(".");	//判断小数点后有几位小数

		if(numsobj.length==1) return price.toFixed(2); //值为0时补充到2位
		if(numsobj.length > 1 && numsobj[1].length <= 2) return price.toFixed(2); //值为小数点后只有1位小数时补充到2位
		if(numsobj.length > 1 && numsobj[1].length > 2) return price; //小数点后的值超出2位时直接返回		
	}
  },

  methods:{
	// 获取打印表格权限
	getPrintPermission() {
		var resource = this.$resource(this.GLOBAL.domain+"Purcharserefund/index");
		resource.query({act:'check_user_procurement_management_price',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				const resData = JSON.parse(Base64.decode(res.body.Data));
				this.pricePerm = resData.is_true
            }
        })
	},

	/** 获取全部供应商列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },



	/** 导出采购退货单 **/  
	exportdata() {
		var url=this.GLOBAL.exportUrl+"Purcharserefund/index/act/exportpurcharserefunddata/token/"+this.$cookies.get('token');
		if(this.order.date.length > 0) url+="/date/"+this.order.date;
		if(this.order.key!='') url+="/key/"+this.order.key;
		if(this.order.status!='') url+="/status/"+this.order.status;
		if(this.order.account!='') url+="/account/"+this.order.account;
		location.href=url;
	},


    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取仓库 **/
    getWarehouse(){
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          
        });
    },
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          
        });
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取供应商信息 **/
	getSupplier() {
	     var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	     resource.query({act:'getapplyAll',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		     if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		     }else{
		        this.supplierlists = JSON.parse(Base64.decode(res.data.Data));	                      
		     }
	     }).catch((res) => {
	            
	     });
	},
	
	/** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var _this=this;
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.brandlists=[];
	            result.forEach(function(e,i) {
	            	_this.brandlists.push({id:e.id,name:e.name});
	            });
	        }
        }).catch((res) => {
            
        });
    },
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            
        });
    },
      
    /** 获取采购退货单信息 **/  
    getorderlists() {
		if(this.orderisselect) {
			this.order.p=1;
			this.order.rollpage=10;
		}

    	this.orderLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.order).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.orderLoading=false;
	        }else{
	            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
	            this.order_total_rows=parseInt(res.data.count);
	            this.orderLoading=false;

				//打印完成刷新页面时重新加载参数
                if(this.$cookies.get('print_back_data_Purcharrefund') && this.$cookies.get('print_back_data_Purcharrefund')!='') {
                    var data=this.$cookies.get('print_back_data_Purcharrefund');
                    data=JSON.parse(data);
                    this.orderisselect=data.orderisselect;
                    this.order=data.order;
                    this.$cookies.set('print_back_data_Purcharrefund','');
                    this.getorderlists();
                }

	        }
        }).catch((res) => {
            this.orderLoading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.order.rollpage = val;
        this.getorderlists();
    },
    orderPageCurrentChange(val) {
        this.order.p = val;
        this.getorderlists();
    },
    
    
    //新增退货单
    add() {
    	this.$emit('listenchild',{name:'新增采购退货单',url:'Purcharrefundadd'});
    	return false;
    
      	this.create.id=0;
      	this.create.applyid='';
      	this.create.clerkid='';
      	this.create.documents='';
      	this.create.account='';
      	this.create.total=0.00;
      	this.create.real=0.00;
      	this.create.derate=0.00;
      	this.create.note='';
      	this.create.goods=[];
    
		this.addDialog=true;
		this.getLists();  //获取购物车商品信息
		this.getdocuments(); //获取订单编号
    },
    
    //获取订单编号
    getdocuments() {
    	var resource = this.$resource(this.url);
        resource.save({act:'getdocuments',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.create.documents=result.documents;         
	        }
        }).catch((res) => {

        });
    },
    
    //获取退货商品信息
    getLists() {
    	this.goodsListLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'gettempgoods',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsListLoading=false;
	        }else{
	            this.create.goods = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsListLoading=false;
	            
	            //计算订单金额、应付金额	            
	            var _this=this;
	            var total=0;
	            var real=0;
	            this.create.goods.forEach(function(e,index) {total += parseFloat(e.total)});
	            real=total-parseFloat(this.create.derate);
	            this.create.total=total.toFixed(2);
	            this.create.real=real.toFixed(2);           
	        }
        }).catch((res) => {
            this.goodsListLoading=false;
        });
    },
    
    //统计合计信息
    totalRule() {
    	var _this=this;
	    var price=0;
	    var num=0;
	    var total=0;	    		    	
	    this.create.goods.forEach(function(e,index) {
			price += parseFloat(e.buy);
			num += parseInt(e.num);
			total += parseFloat(e.total);
		});
		price=price.toFixed(2);
		total=total.toFixed(2);
		return ['合计','','','',price,num,'',total];
    },
    
    //批量添加退货商品
    addDialogmore() {    
      	this.productquery.key='';
      	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.addproductDialog=true;
    	this.multipleSelection=[];
      	this.getProductList();
    },
    
    //点击搜索商品信息
    addDialogShow() {
      	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.addproductDialog=true;
    	this.multipleSelection=[];
      	this.getProductList();
    },
    
    //点击回车按关键字搜索商品，只有一个的直接添加，两个以上的展开列表
    addDialogsingle() {
    	this.productquery.brandid='';
      	this.productquery.catid=[];
      	this.productquery.warehouse=[];
      	this.productquery.clerkid=this.create.clerkid;
      	this.productquery.applyid=this.create.applyid;   
      	this.productselect=true;  
    	this.multipleSelection=[];
    
    	var resource = this.$resource(this.url);
        resource.save({act:'sweep',token:this.$cookies.get('token'),applyid:this.create.applyid,clerkid:this.create.clerkid,key:this.productquery.key}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
				if(result.num==1) {this.multipleSelection.push(result.productid);this.addSave();} //当商品信息只有一个时直接添加进入购物车
				if(result.num > 1) {this.addproductDialog=true;this.getProductList();} //当商品信息有2个以上时弹出选择列表
				 
	        }
        }).catch((res) => {
            
        });
    },
    
    selectbrand() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    selectcate() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    changesearchkey() {
    	this.productselect=true;
    	this.getProductList();
    },
    
    //获取需要添加的商品信息
    getProductList() {
    	if(this.productselect==true) {
    		this.productquery.p=1;
    		this.productquery.rollpage=10;
    	}

    	this.addListLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.productquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addListLoading=false;
	        }else{
	            this.productlists = JSON.parse(Base64.decode(res.data.Data));
	            this.total_product_rows=parseInt(res.data.count);
	            this.addListLoading=false;
	            if(this.productselect==true) this.productselect=false;
	            
	            //已选的商品予以勾选
	            var _this=this;
		        this.productlists.forEach(function(e,index) {
		        	setTimeout(function() {
		            	if(_this.multipleSelection.indexOf(e.id)!= -1) _this.$refs.multipleTable.toggleRowSelection(e);
		        	},100);
		        });
	            
	        }
        }).catch((res) => {
            this.addListLoading=false;
        });
    },
    
	productPageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    productPageCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    },
    
    /** 单行点击触发事件（单击、双击） **/
    rowclick(val,row) {
    	this.nowtime ++;
    	if(this.timeoutflag==false) return false;
    	
    	var _this=this;
    	this.timeoutflag=false;
    	setTimeout(function() {
    		if(_this.nowtime==1) { //单击事件
    			_this.selectrow(val,row);
    		}else { //双击事件
    			_this.selectsingle(val,row);
    		}
    		_this.nowtime=0;
    		_this.timeoutflag=true;
    	},250);
    },
    
    /** 单击事件（选择、取消选择商品） **/
    selectrow(row,event) {
    	var _this=this;
		var id=row.id; //商品id
		var number=0;
		
		this.$refs.multipleTable.toggleRowSelection(row); //选择或取消选中的商品信息
		//检测已添加的商品里是否有该id，无则添加，有则清除
		number=this.multipleSelection.indexOf(id);
		number==-1 ? this.multipleSelection.push(id) : this.multipleSelection.splice(number,1);
    },
    
    /** 双击事件 **/
    selectsingle(val,row) {
    	this.multipleSelection=[];
    	this.multipleSelection.push(row.id);
    	
    	//保存商品信息到购物车
    	this.addSave();
    },
    
    /** 单个点击 **/
    handleSelectsingle(val,row) {
    	if(this.isopenselect==false) return false;
    	var id=row.id;
    	var number=0;
    	number=this.multipleSelection.indexOf(id);
    	number==-1 ? this.multipleSelection.push(id) : this.multipleSelection.splice(number,1);
    	this.isopenselect=true;
    },
    
    /** 全选、全部删除 **/
    handleSelectall(val) {
    	if(this.isopenselect==false) return false;
    	var _this=this;
    	var number;
    	
    	if(val.length>0) { //全选时
    		val.forEach(function(e,index) {
    			_this.multipleSelection.indexOf(e.id)==-1 ? _this.multipleSelection.push(e.id) : "";
    		})
    	}else { //全不选时
    		this.productlists.forEach(function(e,index) {
    			number=_this.multipleSelection.indexOf(e.id);
    			number > -1 ? _this.multipleSelection.splice(number,1) : "";
    		});
    	}
    },
    
    /** 清空选中的商品信息 **/
    cleargoods() {
    	var _this=this;
    	this.productlists.forEach(function(e,index) {
    		_this.multipleSelection.indexOf(e.id)!= -1 ? _this.$refs.multipleTable.toggleRowSelection(e) : "";
		});
    	this.multipleSelection=[];
    },
    
    /** 确认添加商品进入购物车 **/
    addSave() {
    	this.addProductLoading=true;
    	if(this.multipleSelection.length==0) {this.$message.error('请选择需要退货的商品');return false;}
    	var resource = this.$resource(this.url);
        resource.save({act:'addcart',token:this.$cookies.get('token'),ids:this.multipleSelection,createid:this.create.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addProductLoading=false;
	        }else{
	            this.$message.success('新增成功');
	            this.addProductLoading=false;
	            this.addproductDialog=false;
	            this.getLists();
	        }
        }).catch((res) => {
          
        });
    },
    
    /** 复制当前商品信息进入购物车 **/
    copygoods(item) {
    	this.multipleSelection=[];
    	this.multipleSelection.push(item.productid);
    	this.addSave();
    },
    
    /** 删除当前购物车里的商品信息 **/
    delgoods(item) {
    	this.$confirm('您是否需要删除该商品信息？', '提示', { type: 'warning' }).then(() => {
        		// 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'deltempgoods',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.$message.success('删除商品信息成功！');
	                    this.getLists();
	                }
	            }).catch((res) => {
	            	
	            });
	    }).catch(() => {
	            
	    });
    },
    
    //修改优惠金额
    changederate() {
    	if(this.create.derate<0) {this.$message.error("优惠金额不能为负数");this.create.derate=0;this.getLists();return false;}
    	if(isNaN(this.create.derate)) {this.$message.error("请输入正确的优惠金额");this.create.derate=0;this.getLists();return false;}
    	if(parseFloat(this.create.total)<parseFloat(this.create.derate)) {this.$message.error("订单总额不能小于优惠金额");this.create.derate=0;this.getLists();return false;}
    	var real=parseFloat(this.create.total)-parseFloat(this.create.derate);
    	this.create.real=real.toFixed(2);
    },
    
    //修改订单应付金额
    changereal() {
    	if(this.create.real<0) {this.$message.error("应付金额不能为负数");this.create.derate=0;this.getLists();return false;}
    	if(isNaN(this.create.real)) {this.$message.error("请输入正确的应付金额");this.create.derate=0;this.getLists();return false;}
    	if(parseFloat(this.create.total)<parseFloat(this.create.real)) {this.$message.error("订单总额不能小于应付金额");this.create.derate=0;this.getLists();return false;}
    	var derate=parseFloat(this.create.total)-parseFloat(this.create.real);
    	this.create.derate=derate.toFixed(2);
    },
    
    //获取商品单位信息
    getUnitlists(item) {
    	this.unitDialog=true;
    	this.unitListLoading=true;
    	this.unitlists.tempid=item.id;
    	
    	var resource = this.$resource(this.url);
	    resource.save({ act:'getUnitlists',token:this.$cookies.get('token'),productid:item.productid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitListLoading=false;
	        }else{
	        	this.unitlists.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.unitListLoading=false;
	        }
	    }).catch((res) => {
	       this.unitListLoading=false; 	
	    });
    },
    
    //保存修改的单位信息
    changeUnitSave(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'saveunits',token:this.$cookies.get('token'),tempid:this.unitlists.tempid,id:item.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitDialog=false;
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.unitDialog=false;
	            this.getLists();
	        }
	    }).catch((res) => {
	       this.unitDialog=false; 	
	    });
    },
    
    //修改成本价
    setgoodsbuy(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changebuy',token:this.$cookies.get('token'),tempid:item.id,buy:item.buy}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //修改数量信息
    setgoodsnum(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changenums',token:this.$cookies.get('token'),tempid:item.id,num:item.num,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //获取仓库信息
    changewarehouse(item) {
    	this.wareDialog=true;
    	this.wareListLoading=true;
    	this.warehouselists.tempid=item.id;
    	
    	var resource = this.$resource(this.url);
	    resource.save({ act:'getwarelists',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.wareListLoading=false;
	        }else{
	        	this.warehouselists.lists = JSON.parse(Base64.decode(res.data.Data));
	            this.wareListLoading=false;
	        }
	    }).catch((res) => {
	       this.wareListLoading=false; 	
	    });
    },
    
    //保存修改的仓库信息
    changewarehouseSave(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'savewarehouse',token:this.$cookies.get('token'),tempid:this.warehouselists.tempid,id:item.id,applyid:this.create.applyid,clerkid:this.create.clerkid}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.wareDialog=false;
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.wareDialog=false;
	            this.getLists();
	        }
	    }).catch((res) => {
	       this.wareDialog=false; 	
	    });
    },
    
    //修改小计金额
    setgoodstotal(item) {
    	var resource = this.$resource(this.url);
	    resource.save({ act:'changetotal',token:this.$cookies.get('token'),tempid:item.id,total:item.total}).then((res) => {
	    	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getLists();
	        }else{
	        	this.$message.success("修改成功！");
	            this.getLists();
	        }
	    }).catch((res) => {
	
	    });
    },
    
    //关闭当前窗口询问是否需要清除数据
    handleDialogClose() {
    	var isdel=0;
    	if(this.create.id>0 && this.create.goods.length > 0) {
    		var resource = this.$resource(this.url);
		    resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
		    	if(res.data.Result>0){
		        	if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }
		    }).catch((res) => {
		
		    });
    		
    	}else if(this.create.id==0 && this.create.goods.length >0) {
    		this.$confirm('您是否需要保存退货商品信息？', '提示', { type: 'warning' }).then(() => {
	        	var resource = this.$resource(this.url);
			    resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
			    	if(res.data.Result>0){
			        	if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
			        }
			    }).catch((res) => {
			
			    });
		    }).catch(() => {
		            
		    });
    	}
    },
    
    //删除购物车里的全部商品信息
    clearall() {
    	this.$confirm('您是否需要清空全部商品信息？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'deltemps',token:this.$cookies.get('token'),createid:this.create.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("清空商品成功！");
			    	this.getLists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //删除当前订单信息
    delSave() {
    	this.$confirm('您是否需要删除当前的订单信息？', '提示', { type: 'warning' }).then(() => {
    		this.delorderLoading=true;
	        var resource = this.$resource(this.url);
			resource.save({ act:'delorder',token:this.$cookies.get('token'),id:this.create.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.delorderLoading=false;
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("删除订单成功！");
			    	this.addDialog=false;
			    	this.getorderlists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //删除列表页里的订单信息
    delCurrent(item) {
    	this.$confirm('您是否需要删除当前的订单信息？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'delorder',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			    }else {
			    	this.$message.success("删除订单成功！");
			    	this.getorderlists();
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		            
		});
    },
    
    //保存当前的订单信息
    createSave() {
    	this.create.act="saveorder";
    	this.addorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.addorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("保存订单成功！");
			    this.addorderLoading=false;
			    this.create.goods=[];
			    this.addDialog=false;
			    this.getorderlists();
			}
		}).catch((res) => {
			
		});
    },
    
    //审核当前的订单信息
    verifySave() {
    	this.create.act="verifySave";
    	this.verifyorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.verifyorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("审核订单成功！");
			    this.verifyorderLoading=false;
			    this.create.goods=[];
			    this.addDialog=false;
			    this.getorderlists();
			}
		}).catch((res) => {
			
		});
    },
    
    //确认审核并打印
    verifyandprintSave() {
    	this.create.act="verifySave";
    	this.verifyandprintorderLoading=true;
    	var resource = this.$resource(this.url);
		resource.save(this.create).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.verifyandprintorderLoading=false;
			    this.$message.error(res.data.Message);
			}else {
			    this.$message.success("审核订单成功！");
			    var result = JSON.parse(Base64.decode(res.data.Data));
			    this.verifyandprintorderLoading=false;
			    this.create.goods=[];
			    this.addDialog=false;
			    this.getorderlists(); //刷新订单列表
			    this.getprintdetail(result.id); //打印订单
			}
		}).catch((res) => {
			
		});

    },
    
    //编辑商品信息
    editorder(item) {
    	this.$emit('listenchild',{name:'编辑采购退货单',url:'Purcharrefundedit',data:{id:item.id}});
    	return false;
    
    	var resource = this.$resource(this.url);
		resource.save({ act:'editorder',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else {
			    var result = JSON.parse(Base64.decode(res.data.Data));
      	  		this.create.id=item.id;
		      	this.create.applyid=result.applyid;
		      	this.create.clerkid=result.clerkid;
		      	this.create.documents=result.documents;
		      	this.create.account=result.account;
		      	this.create.derate=result.derate;
		      	this.create.note=result.note,
		      	this.create.goods=[],
			    this.addDialog=true;
			    this.getLists();
			}
		}).catch((res) => {
			
		});
    },
    
    showorder(item) {
    	this.getprintdetail(item.id);
    },
    
    //获取订单打印信息
    getprintdetail(id) {
    	this.printLoading=true;
		this.printerDialog=true;
		this.printlists=[];
		var resource = this.$resource(this.url);
		resource.save({act:'getprintinfos',token:this.$cookies.get('token'),id:id,rollpage:this.rollpage}).then((res) => {
		    if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printLoading=false;
		    }else{
		    	this.printLoading=false;
		        this.printlists=JSON.parse(Base64.decode(res.data.Data));
		        console.log("🚀 ~ resource.save ~ this.printlists:", this.printlists)
		        this.orderstatus=this.printlists[0].status;
		    }
		}).catch((res) => {
			this.printLoading=false;
		});  
    },
    
    //修改订单打印每页展示条数
	changepagevlaue() {
	    this.getprintdetail(this.printlists[0].id);
	},
    
    //打印订单
    createnoSave() {
    	var id=this.printlists[0].id;
	    this.printorderLoading=true;
	    var resource = this.$resource(this.url);
		resource.save({act:'changeprintnumber',token:this.$cookies.get('token'),id:id}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.printorderLoading=false;
		    }else{
		        this.printorderLoading=false;
		        this.printlocalpage(); //打印 
		    }
		}).catch((res) => {
			this.printorderLoading=false;
		});
    },
    
    /** 打印当前页面 **/
	printlocalpage() {
		//设置打印完成后回调页面
    	this.$cookies.set('returnurlids','Purcharrefund');
        //保留搜索前的数据
		var data={};
		data.orderisselect=this.orderisselect;
	 	data.order=this.order;
		this.$cookies.set('print_back_data_Purcharrefund',JSON.stringify(data));

	    //设置打印信息
	    var div_print=document.getElementById('printContent');
		var newStr=div_print.innerHTML;
		var oldStr=document.body.innerHTML;
		document.body.innerHTML=newStr;
		window.print();
		document.body.innerHTML=oldStr;	    
		location.reload();
	},
	
	/** 撤销审核 **/
    cannelverify() {
    	this.cannelLoading=true;
    	this.$confirm('您是否确定要撤销该订单信息的审核？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'cannelverify',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.cannelLoading=false;
			    }else {
			    	this.$message.success("订单撤销审核成功！");
			    	this.printerDialog=false;
			    	this.cannelLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.cannelLoading=false;        
		});
    },
    
    /** 完成订单 **/
    finishorder() {
    	this.finishLoading=true;
    	this.$confirm('您是否确定要完成该订单？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'finishorder_news',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.finishLoading=false;
			    }else {
			    	this.$message.success("退货订单完成操作成功！");
			    	this.printerDialog=false;
			    	this.finishLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.finishLoading=false;        
		});
    },
    
    
    /** 撤销已完成订单 **/
    cannelfinish() {
    	this.cannelfinishLoading=true;
    	this.$confirm('您是否确定要将该订单的状态修改成已审核？', '提示', { type: 'warning' }).then(() => {
	        var resource = this.$resource(this.url);
			resource.save({ act:'cannelfinish',token:this.$cookies.get('token'),id:this.printlists[0].id}).then((res) => {
			    if(res.data.Result>0){
			        if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
			        this.cannelfinishLoading=false;
			    }else {
			    	this.$message.success("订单撤销审核成功！");
			    	this.printerDialog=false;
			    	this.cannelfinishLoading=false;
			    	this.getorderlists(); //刷新订单列表
			    }
			}).catch((res) => {
			
			});
		}).catch(() => {
		    this.cannelfinishLoading=false;        
		});
    },

  },

}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/purchase/Purcharrefund.vue